import { CreateTRPCClientOptions, createTRPCClient } from "@trpc/client";
import { httpLink } from "@trpc/client/links/httpLink";
import { createTRPCReact } from "@trpc/react-query";

import type { TrpcAppRouter } from "@/trpc";
import { BASE_ROUTE } from "lib/env";

const cmTrpcReact = createTRPCReact<TrpcAppRouter>();
export const trpc = cmTrpcReact; // alias for ease of use, since this is the most common one

// Remove duplicate /api/ from route, temporary until we have time to look at why this happens on Vercel
const trpcBaseUrl = `${BASE_ROUTE}/api/trpc/cm`.replace("/api/api/", "/api/");

function getTrpcClientParams() {
  const params: CreateTRPCClientOptions<TrpcAppRouter> = {
    links: [
      httpLink<TrpcAppRouter>({
        url: trpcBaseUrl,
        fetch(url, options) {
          // Send cookies cross-origin
          // @see https://trpc.io/docs/v10/cors
          return fetch(url, {
            ...options,
            credentials: "include",
          });
        },
      }),
    ],
  };
  return params;
}

export function createCmTrpcReactClient() {
  return cmTrpcReact.createClient(getTrpcClientParams());
}

export function createCmTrpcVanillaClient() {
  return createTRPCClient<TrpcAppRouter>(getTrpcClientParams());
}
export const trpcCmVanilla = createCmTrpcVanillaClient();

export type CmTrpcReactClient = ReturnType<typeof createCmTrpcReactClient>;
